// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KSJ6Y","largestCol":"styles_largestCol__1GRz4","smallestCol":"styles_smallestCol__1k4v8"};